module.exports = __webpack_public_path__ + "static/media/404-image.ab70863e.jpg";